import 'selection-model';
import 'angular-ui-bootstrap';

import './style.styl';

angular
  .module(__filename, [
    'selectionModel',
    'ui.bootstrap',

    require('local_modules/filters/dropoff_window').default.name,
    require('local_modules/filters/format_status').default.name,
    require('local_modules/filters/display_order_unit').default.name,
    require('local_modules/filters/to_dollars').default.name,
    require('local_modules/directives/input_quantity').default,
    require('local_modules/directives/input_cents').default,

    require('goodeggs-purchase-orders-sdk/purchase_order/angular_resource'),
    require('local_modules/services/purchase_order_product').default,
    require('local_modules/services/purchasing_uom').default,
    require('local_modules/modals/confirm_action_modal').default,
    require('local_modules/services/external_urls').default,

    require('./components/po_form').default,
    require('./components/po_line_item_forms').default,
    require('./modals/submit_po_confirmation_modal').default,
    require('./modals/foodhub_selection_modal').default,
    require('./modals/reconfirm_po_confirmation_modal').default,
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('purchase_orders.show', {
        url: '/show/:poNumber',
        template: require('./template'),
        controllerAs: 'ctrl',
        controller: require('./controller').default,
      }),
    ),
  );

export default __filename;
